export default __webpack_public_path__ + "static/media/13.0c9a89e6.jpg";